import React, {Component} from 'react'
import PropTypes from "prop-types"
import {getSkuSizesShippingCarrier, deleteSizesSkuShippingCarrier, getSkuSizesTab, deleteSizesSkuTab} from '../../../../services/api/apiSku'
import TableBody from './TableBody'
import SkuSizeTabs from './SkuSizeTabs'
import PubSub from "pubsub-js"
import {getLocalData} from "../../../../services/StorageServices";
import {parseJwt} from "../../../../share/parseToken";

class SkuSize extends Component {
    state = {
        sizes: [],
        loading: false,
        error: '',
        shippingCarrier: 'default',
        objectType: 'shipping-carrier',
        objectName: 'default'
    }

    componentDidMount() {
        this._handleGetSizes()
    }

    _handleChangeTab = (objectType, objectName) => {
        this.setState({
            // shippingCarrier: value,
            objectType,
            objectName
        }, () => {
            this._handleGetSizes()
        })
    }

    handleAddSize = () => {
        const {sizes} = this.state
        const newItem = {
            sku: "",
            width: 0,
            height: 0,
            length: 0,
            weight: 0,
            weight_by_v: 0,
            created_at: "",
            updated_at: "",
            type: "add",
            box_weight: '',
            full_size_weight: '',
        }
        sizes.push(newItem)

        this.setState({
            sizes: sizes
        })
    }

    _handleGetSizes = async () => {
        const {skuID} = this.props
        const {shippingCarrier, objectType, objectName} = this.state

        this.setState({
            sizes: [],
            loading: true,
            error: ''
        })

        try {
            const {data: respon} = await getSkuSizesTab(skuID, objectType, objectName)
            const {success, data, message} = respon

            if (!success) return this.setState({
                loading: false,
                error: message
            })

            const _sizes = data.map(item => {
                const {package_mockup = [], package_description = '', box_weight, full_size_weight} = Object.assign({}, item)
                return {
                    sku: item.sku,
                    width: item.dimension.width,
                    height: item.dimension.height,
                    length: item.dimension.length,
                    weight: item.dimension.weight,
                    additional_weight: item.dimension.additional_weight,
                    weight_by_v: item.weight_by_v,
                    created_at: item.created_at,
                    updated_at: item.hasOwnProperty('updated_at') ? item.updated_at : '',
                    _id: item._id,
                    type: '',
                    shipping_carrier: item.shipping_carrier || 'default',
                    base_cost: item.base_cost,
                    package_mockup,
                    package_description,
                    box_weight,
                    full_size_weight
                }
            })

            this.setState({
                sizes: _sizes,
                error: '',
                loading: false
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            })
        }
    }

    _onDeleteSizesByObject = async (objectType, objectName) => {
        this.setState({
            loading: true,
            error: ''
        })
        try {
            const {skuID} = this.props

            const {data: response} = await deleteSizesSkuTab(skuID, objectType, objectName)

            const {success, message} = response

            if (!success) return this.setState({
                loading: false,
                error: message
            })

            this.setState({
                loading: false,
                shipping_carrier: 'default',
                objectType: 'shipping-carrier',
                objectName: 'default'
            }, () => {
                PubSub.publish('GET_LIST_TAB')
                this._handleGetSizes()
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            })
        }
    }

    _renderTableContent = (shippingCarrier = '') => {
        const {sizes, error, loading, objectType, objectName} = this.state
        const {skuID, isFFMView} = this.props

        if (error) {
            return <tr>
                <td colSpan={isFFMView ? 12 : 11} className="text-danger">{error}</td>
            </tr>
        }

        if (sizes.length === 0) {
            if (loading) return <tbody>
            <tr>
                <td colSpan={isFFMView ? 12 : 11}>Đang tải...</td>
            </tr>
            </tbody>

            return <tbody>
            <tr>
                <td colSpan={isFFMView ? 12 : 11}>Không có dữ liệu.</td>
            </tr>
            <tr>
                <td colSpan={isFFMView ? 12 : 11} className="text-center cursor-pointer pt-3" onClick={this.handleAddSize}>
                    <i className="icon-plus-circle2 text-success"/> Thêm Size
                </td>
            </tr>
            </tbody>
        }

        return <TableBody isFFMView={isFFMView} sizes={sizes} skuID={skuID} onAddSize={this.handleAddSize} onGetSizes={this._handleGetSizes} objectType={objectType} objectName={objectName}/>
    }

    _handleChangeSizes = (sizes) => {
        this.setState({sizes})
    }

    render() {
        const {sizes} = this.state
        const {isFFMView, brandOptions, listTab, skuID} = this.props

        return (
            <div className="SkuSize mb-3">
                <SkuSizeTabs
                    skuID={skuID}
                    isFFMView={isFFMView}
                    renderTableContent={this._renderTableContent}
                    changeTab={this._handleChangeTab}
                    onDeleteSizesByObject={this._onDeleteSizesByObject}
                    brandOptions={brandOptions}
                    listTab={listTab}
                    sizes={sizes}
                    onChangeSizes={this._handleChangeSizes}
                    onGetSizes={this._handleGetSizes}
                />
            </div>
        )
    }
}

SkuSize.propTypes = {
    skuID: PropTypes.string.isRequired
}

export default SkuSize
